import { useEffect } from "react";
import apiCall from "../../../utility/api";

type dataProps = {
	func?: any;
	data?: any;
	pageNo?: any;
	searchVal?: string
	setTotalRecords?: any
	setTotalPages?: any
	isfilter?: boolean
	filterArray?: any
	setIsFilter?: any
	setRefresh?: any
	setRefreshToast?: any
	dropDownValue1?: any
	dropDownValue2?: any
	isRefresh?: any
	setIsRefresh?: any
	setIsToast?: any
	totalRecords?: any
	setExportBtnClicked?: any
	exportBtnClicked?: any
	tenant?: string
	setExportDetails?: any;
};
const Monitor_func = (props: dataProps) => {
	useEffect(() => {
		if (props.searchVal.length > 0 && props.searchVal !== '') {
			getAlertsList("search", { name: props.searchVal }, 50, parseInt(props.pageNo));
			getAlertsListCnt("search", { name: props.searchVal })
		} else if (props.isfilter === true) {
			getAlertsList("filter", { filter: props.filterArray }, 50, parseInt(props.pageNo));
			getAlertsListCnt("filter", { filter: props.filterArray });
		} else {
			getAlertsList(null, null, 50, parseInt(props.pageNo));
			getAlertsListCnt(null);
		}
	}, [props.searchVal, props.searchVal.length, props.isfilter, props.filterArray, props.pageNo]);

	useEffect(() => {
		if (props.exportBtnClicked) {
			getExportData({ function: 'export', tenant: props.tenant });
		}
		if (props.isRefresh) {
			getAlertsList(null, 50, parseInt(props.pageNo));
			getAlertsListCnt(null);
		}
	}, [props.isRefresh,props.exportBtnClicked])

	const getAlertsList = async (
		type: string | null = '',
		searchVal: any = null,
		limit: Number = 50,
		offset: Number = 0
	) => {
		try {
			let { status, data } = await apiCall('/alerts/getAlertsList', { type, searchVal, limit, offset })
			if (status === 'success') {
				props.func(data)
			}
		} catch (error) {
			console.error("An unexpected error occurred at AlertList API call:", (error as Error).message);
			props.func([])
		}
	};

	const getAlertsListCnt = async (type: string | null = '', searchVal: any = null) => {
		try {
			let { status, data } = await apiCall('/alerts/getAlertsListCount', { type, searchVal })
			if (status === 'success') {
				props.setTotalRecords(data);
				props.setTotalPages(Math.ceil((data) / 50));
			}
		} catch (error) {
			console.error("An unexpected error occurred:", (error as Error).message);
		}
	};

	const getExportData = async (condition: object) => {
		try {
			const { status, data } = await apiCall(`/alerts/getAlertsList`, {
				...condition, // Spread the condition object to pass all expected keys
			});
			if (status === 'success') {
				props.setExportDetails && props.setExportDetails(data);
			}
		} catch (error) {
		}
		props.setExportBtnClicked(false);
	}
	// const getAlertsList = async (
	//   whereCondition: any,
	//   limit: Number,
	//   offset: Number
	// ) => {
	//   try {
	//     const { data, loading, error } = await client.query({
	//       query: getAlertsListsQuery,
	//       variables: { whereCondition, limit, offset },
	//       fetchPolicy: "network-only",
	//     });
	//     if (!loading && data) {
	//       props.func(data);
	//     }
	//   } catch (error) {
	//     console.error("An unexpected error occurred:", (error as Error).message);
	//   }
	// };
	return <></>;
};

export default Monitor_func;
